import { Directive, ElementRef, Input, OnChanges, OnDestroy, OnInit, Renderer2, Optional, Host } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { PhxRowComponent } from './phx-row.component';
import { BreakpointsMap } from './phx-grid.constants';
import { PhxCSSClassMap } from './phx-grid.types';
import { isNil } from '../../utils';

@Directive({
  selector: '[phx-col],phx-col',
  exportAs: 'phxCol',
})
export class PhxColDirective implements OnInit, OnChanges, OnDestroy {
  @Input() phxSpan: string | number;
  @Input() phxOrder: string | number;
  @Input() phxXsMobile: string | number;
  @Input() phxSmMobile: string | number;
  @Input() phxSmTablet: string | number;
  @Input() phxMdTablet: string | number;
  @Input() phxLgDesktop: string | number;
  @Input() phxXlDesktop: string | number;

  private _classMap: PhxCSSClassMap = {};
  private _destroy$: Subject<void> = new Subject();

  constructor(private _elemRef: ElementRef, private _renderer: Renderer2, @Optional() @Host() private _phxRowDirective: PhxRowComponent) {}

  public ngOnInit(): void {
    this.setHostClassMap();
  }

  public ngOnChanges(): void {
    this.setHostClassMap();
  }

  public ngAfterViewInit(): void {
    if (this._phxRowDirective) {
      this._phxRowDirective.actualGutter$.pipe(takeUntil(this._destroy$)).subscribe(([horizontalGutter, verticalGutter]) => {
        const renderGutter = (name: string, gutter: number | null) => {
          const nativeElement = this._elemRef.nativeElement;
          if (gutter !== null) {
            this._renderer.setStyle(nativeElement, name, `${gutter / 2}px`);
          }
        };
        renderGutter('padding-left', horizontalGutter);
        renderGutter('padding-right', horizontalGutter);
        renderGutter('padding-top', verticalGutter);
        renderGutter('padding-bottom', verticalGutter);
      });
    }
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  private setHostClassMap(): void {
    const hostClassMap = {
      ['phx-col']: true,
      [`phx-col-${this.phxSpan}`]: !isNil(this.phxSpan),
      [`phx-col-order-${this.phxOrder}`]: !isNil(this.phxOrder),
      ...this.generateClass(),
    };
    for (const i in this._classMap) {
      if (this._classMap.hasOwnProperty(i)) {
        this._renderer.removeClass(this._elemRef.nativeElement, i);
      }
    }
    this._classMap = { ...hostClassMap };
    for (const i in this._classMap) {
      if (this._classMap.hasOwnProperty(i) && this._classMap[i]) {
        this._renderer.addClass(this._elemRef.nativeElement, i);
      }
    }
  }

  private generateClass(): PhxCSSClassMap {
    const listClassMap: PhxCSSClassMap = {};
    Object.keys(BreakpointsMap).forEach((name) => {
      const sizeName = BreakpointsMap[name];
      const size = this[name];
      if (!isNil(size)) listClassMap[`phx-col-${sizeName}-${size}`] = true;
    });
    return listClassMap;
  }
}
